import { render } from "./DefaultSettingsPanel.vue?vue&type=template&id=5a4a83b7"
import script from "./DefaultSettingsPanel.vue?vue&type=script&lang=js"
export * from "./DefaultSettingsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__